import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { Divider, Box, Typography } from '@mui/material';
import { actions } from '../../../../redux/reducers/prescriptionReducer';
import Prescriber from './prescriber';
import PrescribersProfile from './prescriberProfile';
import { CustomModal } from '../../../shared';
import routeNames from '../../../../routes/routeNames';
import PrescriberSekeleton from './prescriberSkeleton';
import { handleCustomisationForCompanyDashboard } from '../../../../utility';
import { REGENERON_COMPANY_ID } from '../../../../constants';
import { handlePrescribersHeading } from '../../../../utility/companySpecificFunctions';

const TopPriscribers = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setSelectedNPI } = actions;
    const { prescribers, isPrescriberLoading } = useSelector(
        (state) => state.engagement,
    );
    const { company } = useSelector((state) => state.company);

    const [showModal, setShowModal] = useState(false);

    const handleShowModal = (npiId) => {
        if (company.id === 102) return;

        dispatch(setSelectedNPI(npiId));
        handleModal();
    };

    const handleModal = () => {
        setShowModal(!showModal);
    };

    const handleTopPrescriberNavigate = () => {
        navigate(routeNames.TOP_PRESCRIBERS);
    };

    const hideViewAll = () => {
        let bool = true;
        switch (company.id) {
            case 3: // Tepmetko
                bool = false;
                break;
            case 16: // Bavencio
                bool = false;
                break;
            case 18: // Yescarta
                bool = false;
                break;
            case 20: // Tecartus
                bool = false;
                break;
            default:
                bool = true;
                break;
        }
        return bool;
    };

    const renderNoPrerscriber = () => (
        <Typography className="text-sm-regular gray-900">
            No {handlePrescribersHeading(company.id) ? 'engager' : 'prescriber'}{' '}
            performance data to display
        </Typography>
    );
    const renderPrescriber = () =>
        prescribers && prescribers.length > 0 ? (
            <Box>
                {prescribers.map((prescriber, index) => (
                    <Box key={'prescriber-container' + uuidv4()}>
                        <Prescriber
                            handleModal={() => handleShowModal(prescriber.id)}
                            key={'prescriber' + prescriber.id}
                            prescriber={prescriber}
                        />
                    </Box>
                ))}
            </Box>
        ) : (
            renderNoPrerscriber()
        );

    return (
        <>
            <Box
                className="top-prescriber-container"
                data-testid="top_prescribers_list"
            >
                <Box className="flex-row-space-between">
                    <Box>
                        <Typography className="text-md-medium gray-900">
                            Top{' '}
                            {handlePrescribersHeading(company.id)
                                ? 'Engagers'
                                : /* : REGENERON_COMPANY_ID === company.id  // need to fix after some time
                                    ? 'BsAb class users (YTD)' */
                                  'Prescribers'}
                        </Typography>
                    </Box>
                    {prescribers && prescribers.length > 0 ? (
                        <Box onClick={handleTopPrescriberNavigate}>
                            {hideViewAll() && (
                                <Typography className="text-sm-medium gray-500 icon">
                                    View all
                                </Typography>
                            )}
                        </Box>
                    ) : null}
                </Box>
                <Divider className="mt-12px mb-24px border-1-gray" />
                {isPrescriberLoading
                    ? Array.from({ length: 8 }).map((_, index) => (
                          <PrescriberSekeleton
                              key={'prescriber-skeleton' + index}
                          />
                      ))
                    : renderPrescriber()}
            </Box>
            {company.id !== 102 && (
                <CustomModal
                    component={<PrescribersProfile handleClose={handleModal} />}
                    modalOpen={showModal}
                    onClose={handleModal}
                />
            )}
        </>
    );
};

export default TopPriscribers;
